@use "~theme/typography";

.counter {
  color: var(--blue-01);
  text-align: right;
  font-weight: normal;

  @include typography.caption;
}
